var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPointerGreenIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 25,
    viewBox: "0 0 18 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.00033 10.1133V5.75C5.00033 4.14 6.30699 2.83333 7.91699 2.83333C9.52699 2.83333 10.8337 4.14 10.8337 5.75V10.1133C12.2453 9.16833 13.167 7.57 13.167 5.75C13.167 2.845 10.822 0.5 7.91699 0.5C5.01199 0.5 2.66699 2.845 2.66699 5.75C2.66699 7.57 3.58866 9.16833 5.00033 10.1133ZM16.4803 15.515L11.1837 12.8783C10.9853 12.7967 10.7753 12.75 10.5537 12.75H9.66699V5.75C9.66699 4.78167 8.88533 4 7.91699 4C6.94866 4 6.16699 4.78167 6.16699 5.75V18.28C1.96699 17.3933 2.03699 17.405 1.88533 17.405C1.52366 17.405 1.19699 17.5567 0.963659 17.79L0.0419922 18.7233L5.80532 24.4867C6.12032 24.8017 6.56366 25 7.04199 25H14.9637C15.8387 25 16.5153 24.3583 16.6437 23.5067L17.5187 17.3583C17.5303 17.2767 17.542 17.195 17.542 17.125C17.542 16.4017 17.0987 15.7717 16.4803 15.515Z",
    fill: "#2DB875"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPointerGreenIcon);
export default __webpack_public_path__ + "static/media/pointer-green_icon.0ae59ecc52bbc7201703290b5ce05d3c.svg";
export { ForwardRef as ReactComponent };